import {
    FormControl,
    FormControlProps,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Select,
    SelectProps,
    Typography,
    useTheme,
} from '@mui/material'
import { ReactNode } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

const FormSelect_v2 = <T extends FieldValues>({
    name,
    control,
    options,

    selectProps,
    controlProps,

    formLabel,
    formHelperText,

    placeholder,

    // props,
    // sx,
    // controlProps,
    // variant,

    onChange,
}: {
    name: Path<T>
    control: Control<T>
    options: { label: ReactNode; value: any; [x: string]: any }[]

    selectProps?: SelectProps
    controlProps?: FormControlProps

    formLabel?: ReactNode
    formHelperText?: ReactNode
    placeholder?: string

    onChange?: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | (Event & {
                  target: {
                      value: unknown
                      name: string
                  }
              }),
        option?: any
    ) => void
}) => {
    const theme = useTheme()
    return (
        <Controller
            name={name}
            control={control}
            render={(renderProps) => (
                <FormControl
                    {...controlProps}
                    // sx={sx}
                    error={!!renderProps.fieldState.error}
                    variant={selectProps?.variant}
                >
                    {formLabel ? (
                        <FormLabel sx={{ mb: 1.5 }}>{formLabel}</FormLabel>
                    ) : null}
                    <FormControl
                        error={!!renderProps.fieldState.error}
                        variant={selectProps?.variant}
                    >
                        {!!selectProps?.label ? (
                            <InputLabel>{selectProps.label}</InputLabel>
                        ) : null}
                        <Select
                            {...selectProps}
                            name={name}
                            value={renderProps.field.value || ''}
                            displayEmpty={selectProps?.label ? undefined : true}
                            onChange={(e) => {
                                renderProps.field.onChange(e)
                                onChange?.(
                                    e,
                                    options.find(
                                        (el) => el.value === e.target.value
                                    )
                                )
                            }}
                        >
                            {placeholder ? (
                                <MenuItem value="" disabled>
                                    <Typography
                                        color={theme.palette.neutrals[500]}
                                    >
                                        {placeholder}
                                    </Typography>
                                </MenuItem>
                            ) : null}
                            {options.map((el, i) => (
                                <MenuItem
                                    key={`${name}_select_${i}`}
                                    value={el.value}
                                >
                                    {el.label}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                            {renderProps.fieldState.error?.message}
                        </FormHelperText>
                    </FormControl>
                    {/* {!!renderProps.fieldState.error?.message ? ( */}
                    {/* ) : undefined} */}
                </FormControl>
            )}
        />
    )
}

export default FormSelect_v2
